import { BcAntenatalRadioTextboxField } from "../BcAntenatalRadioTextboxField";

class BritishColumbiaObstetricalFileFamilyHistory {
    public AnestheticComplications: BcAntenatalRadioTextboxField;
    public Hypertension: BcAntenatalRadioTextboxField;
    public Thromboembolic: BcAntenatalRadioTextboxField;
    public Diabetes: BcAntenatalRadioTextboxField;
    public MentalHealth: BcAntenatalRadioTextboxField;
    public SubstanceUseDisorder: BcAntenatalRadioTextboxField;
    public InheritedConditionsOrDefects: BcAntenatalRadioTextboxField;
    public Mother: string;
    public BiologicalFatherOrDonor: string;
    public Other: BcAntenatalRadioTextboxField;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileFamilyHistory>) {
        Object.assign(this, fields);
        this.AnestheticComplications = new BcAntenatalRadioTextboxField(fields?.AnestheticComplications);
        this.Hypertension = new BcAntenatalRadioTextboxField(fields?.Hypertension);
        this.Thromboembolic = new BcAntenatalRadioTextboxField(fields?.Thromboembolic);
        this.Diabetes = new BcAntenatalRadioTextboxField(fields?.Diabetes);
        this.MentalHealth = new BcAntenatalRadioTextboxField(fields?.MentalHealth);
        this.SubstanceUseDisorder = new BcAntenatalRadioTextboxField(fields?.SubstanceUseDisorder);
        this.InheritedConditionsOrDefects = new BcAntenatalRadioTextboxField(fields?.InheritedConditionsOrDefects);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public setEmptyFieldsAsNo(): void {
        this.AnestheticComplications.Value ??= false;
        this.Hypertension.Value ??= false;
        this.Thromboembolic.Value ??= false;
        this.Diabetes.Value ??= false;
        this.MentalHealth.Value ??= false;
        this.SubstanceUseDisorder.Value ??= false;
        this.InheritedConditionsOrDefects.Value ??= false;
        this.Other.Value ??= false;
    }
}

export { BritishColumbiaObstetricalFileFamilyHistory };
